<template>
    <v-card :loading="saving" class="pa-4">
      <v-card-title class="d-flex align-center justify-space-between pb-4">
        <div class="headline">
          <v-icon left color="primary">mdi-folder-law</v-icon>
          Case Details: <span class="primary--text">{{ localCase.internalRef || 'New Case' }}</span>
        </div>
        <!-- <v-chip :color="getStatusColor(localCase.status)" dark small class="text-uppercase">
          {{ localCase.status || 'Draft' }}
        </v-chip> -->
      </v-card-title>
  
      <v-divider class="mb-6"></v-divider>
  
      <v-form ref="form" v-model="valid">
        <v-row dense>
          <!-- Reference Codes -->
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="localCase.internalRef"
              label="Internal Reference"
              outlined
              dense
              readonly
              required
              :rules="[v => !!v || 'Internal Reference is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="localCase.courtCaseNo"
              @change="updateSelectedCaseFields('courtCaseNo')"
              label="Court Case Number"
              outlined
              dense
            ></v-text-field>
          </v-col>
  
          <!-- Client & Defendant -->
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="localCase.clientRef"
              @change="updateSelectedCaseFields('clientRef')"
              label="Client Reference"
              outlined
              readonly
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="localCase.respondent"
              @change="updateSelectedCaseFields('respondent')"
              label="Respondent Name"
              outlined
              dense
            ></v-text-field>
          </v-col>
  
          <!-- Case Parameters -->
          <v-col cols="12" sm="6">
            <AutoCompleteCrudAdvanced class="" table="legal_services_types" label="Matter Type" @input="getSelectedMatterType" :value="selectedCase.case_type_id"></AutoCompleteCrudAdvanced>
            <!-- <v-text-field
              v-model="localCase.claimType"
              @change="updateSelectedCaseFields('claimType')"
              label="Claim Type"
              outlined
              dense
            ></v-text-field> -->
          </v-col>
          <v-col cols="12" sm="6">
            <AutoCompleteCrudAdvanced class="mb-n7" table="legal_case_phases" label="Matter Phase" @input="getSelectedMatterPhase" :value="selectedCase.matter_phase_id"></AutoCompleteCrudAdvanced>
            <!-- <v-select
              v-model="localCase.trial"
              @change="updateSelectedCaseFields('trial')"
              :items="['yes', 'no']"
              label="Trial Set?"
              outlined
              dense
            ></v-select> -->
          </v-col>
  
          <!-- Trust Balance -->
          <v-col cols="12" sm="6">
            <AutoCompleteCrudAdvanced class="mb-n7" table="legal_case_attorneys" label="Assigned Attorney" @input="getSelectedAttorney" :value="selectedCase.assigned_attorney_id"></AutoCompleteCrudAdvanced>
           <!--  <v-text-field
              v-model.number="localCase.trustBalance"
              @change="updateSelectedCaseFields('trustBalance')"
              label="Trust Balance"
              prefix="R"
              type="number"
              outlined
              dense
            ></v-text-field> -->
          </v-col>
          <v-col cols="12" sm="6">
            
            <v-text-field
            class="mt-n2"
              v-model="localCase.seat_of_court"
              @change="updateSelectedCaseFields('seat_of_court')"
              label="Seat of Court eg. Durban"
              outlined
              dense
            ></v-text-field>
          </v-col>
  
          <!-- Dates (Using Menus for Mobile and Desktop compatibility) -->
          <v-col cols="12" sm="6">
            <v-menu
              v-model="instructionDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="localCase.instruction_date"
                  label="Instruction Date"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="localCase.instruction_date"
                @change="updateSelectedCaseFields('instruction_date')"
                no-title
                scrollable
                @input="instructionDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
  
          <!-- <v-col cols="12" sm="6">
            <v-menu
              v-model="prescriptionDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="localCase.prescriptionDate"
                 
                  label="Prescription Date"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="localCase.prescriptionDate"
                no-title
                scrollable
                @change="updateSelectedCaseFields('prescriptionDate')"
                @input="prescriptionDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col> -->
  
          <!-- Location -->
          <v-col cols="12">
            <v-text-field
              v-model="localCase.accidentLocation"
              label="Incident Location"
              prepend-inner-icon="mdi-map-marker"
              outlined
              dense
              @change="updateSelectedCaseFields('accidentLocation')"
            ></v-text-field>
          </v-col>
  
          <!-- Long Text Area (Merits Summary) -->
          <v-col cols="12">
            <v-textarea
              v-model="localCase.meritsSummary"
              label="Merits Summary"
              outlined
              auto-grow
              rows="3"
              @change="updateSelectedCaseFields('meritsSummary')"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
  
      <v-divider class="my-4"></v-divider>
  
      <!-- <v-card-actions class="px-0 pb-0">
        <v-btn text color="secondary" @click="resetForm" :disabled="saving">
          Reset Changes
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          depressed
          :loading="saving"
          :disabled="!valid"
          @click="saveCase"
        >
          <v-icon left>mdi-content-save</v-icon>
          Save Details
        </v-btn>
      </v-card-actions> -->  
    </v-card>
  </template>
  
  <script>
  import helpersJs from '@/plugins/helpers';
  import AutoCompleteCrudAdvanced from '@/modules/CrudDatabases/AutoCompleteCrudAdvanced.vue';
  export default {
    name: 'CaseDetailCard',
    props: {
      selectedCase: {
        type: Object,
        required: true,
        default: () => ({})
      }
    },
    components:{AutoCompleteCrudAdvanced},
    data: () => ({
      caseTable: 'legal_cases',
      valid: true,
      saving: false,
      localCase: {},
      instructionDateMenu: false,
      prescriptionDateMenu: false
    }),
    // mounted(){console.log(this.selectedCase)},
    watch: {
      selectedCase: {
        handler(newVal) {
          // Deep copy the prop to prevent direct mutations of state
          this.localCase = JSON.parse(JSON.stringify(newVal));
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      getStatusColor(status) {
        if (!status) return 'grey';
        const s = status.toLowerCase();
        if (s.includes('new')) return 'info';
        if (s.includes('active') || s.includes('trial')) return 'warning';
        if (s.includes('closed') || s.includes('settled')) return 'success';
        return 'grey darken-1';
      },
      resetForm() {
        this.localCase = JSON.parse(JSON.stringify(this.selectedCase));
        if (this.$refs.form) this.$refs.form.resetValidation();
      },
      //done
      async getSelectedMatterType(matterType){
        await this.updateModelSingleRow(this.caseTable, 'case_type_id', this.localCase.id, matterType.id)
      },
      //done
      async getSelectedMatterPhase(matterPhase){
        await this.updateModelSingleRow(this.caseTable, 'matter_phase_id', this.localCase.id, matterPhase.id)
      },
      //done
      async getSelectedAttorney(AssignedAttorney){
        await this.updateModelSingleRow(this.caseTable, 'assigned_attorney_id', this.localCase.id, AssignedAttorney.id)
      },
      //done
      async updateModelSingleRow(table, column, id, value){
        this.$store.commit("setLoader",true)
        await helpersJs.updateModelSingleRow(table, column, id, value)
        this.$store.commit("setLoader",false)
        this.$emit('save', this.localCase);
        this.$toast.success("Data updated successfully!",{duration:5000})
      },
      //done
      async updateSelectedCaseFields(columnName){
        await this.updateModelSingleRow(this.caseTable, columnName, this.localCase.id, this.localCase[columnName])
      },
      async saveCase() {
        if (!this.$refs.form.validate()) return;
        this.saving = true;
        try {
          // Bubble up the payload to your parent component or store handling the update API
          this.$emit('save', this.localCase);
        } finally {
          this.saving = false;
        }
      }
    }
  };
  </script>